import { createSelector } from '@reduxjs/toolkit';

import { selectContentApp } from '../externalContent/ExternalContent.selectors';
import { TriviaInfoItem } from './Trivia.types';

export const selectTrivia = createSelector(
  selectContentApp<TriviaInfoItem>,
  (data: TriviaInfoItem[] | undefined) => data,
);
